import logo from "assets/images/integrations/newsletter2go_logo.png";
import { useCallback, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { connect, ConnectedProps } from "react-redux";
import { RootReduxState } from "../../../../../utils/types";
import { AvailableIntegrationCardAddButton } from "../../components/AvailableIntegrationCardAddButton";
import { AvailableIntegrationCardExplanationWrapper } from "../../components/AvailableIntegrationCardExplanationWrapper";
import { AvailableIntegrationCardHeader } from "../../components/AvailableIntegrationCardHeader";
import { AvailableIntegrationCardWrapper } from "../../components/AvailableIntegrationCardWrapper";
import { UsernamePasswordSetup } from "../../components/UsernamePasswordSetup/UsernamePasswordSetup";
import { ConnectViewComponentProps, IntegrationType } from "../../types";
import { Newsletter2GoIntegrationSettings } from "./types";

type Newsletter2GoConnectViewComponentOwnProps = ConnectViewComponentProps;

const mapStateToProps = (state: RootReduxState) => {
  const selectedShop = state.getIn([
    "customerBackendDashboard",
    "userData",
    "selectedShop"
  ]) as string;

  return {
    integrationList: state
      .getIn([
        "customerBackendDashboard",
        "shops",
        selectedShop,
        "integrations",
        "data",
        IntegrationType.NEWSLETTER_2_GO
      ])
      ?.toJS() as Newsletter2GoIntegrationSettings[] | undefined
  };
};

const connector = connect(mapStateToProps);

type Newsletter2GoConnectViewComponentProps = Newsletter2GoConnectViewComponentOwnProps &
  ConnectedProps<typeof connector>;

const Newsletter2GoConnectViewComponent = (props: Newsletter2GoConnectViewComponentProps) => {
  const { connectingType, onStartConnecting, onStopConnecting, integrationList } = props;

  const isConnected = useMemo(
    () =>
      integrationList?.some((integration) => {
        return integration.oath2Config && integration.oath2Config.access_token;
      }) || false,
    [integrationList]
  );

  return (
    <AvailableIntegrationCardWrapper>
      {connectingType === IntegrationType.NEWSLETTER_2_GO && (
        <UsernamePasswordSetup
          authKeyVisible={true}
          integrationType={IntegrationType.NEWSLETTER_2_GO}
          onFinish={onStopConnecting}
        />
      )}
      <AvailableIntegrationCardHeader image={logo} text="Newsletter2Go" />
      <AvailableIntegrationCardExplanationWrapper>
        <FormattedMessage
          id="containers.Integrations.ListOfApps.Shared.Long.Explanation"
          defaultMessage="Connect your {tool} account with uptain. Then new newsletter subscribers can be added to your account and you can use whitelists for Abandonment-Mails."
          values={{ tool: "Newsletter2Go" }}
        />
      </AvailableIntegrationCardExplanationWrapper>
      <AvailableIntegrationCardAddButton
        isConnected={isConnected}
        loading={connectingType !== undefined}
        onConnect={useCallback(
          () => onStartConnecting(IntegrationType.NEWSLETTER_2_GO),
          [onStartConnecting]
        )}
      />
    </AvailableIntegrationCardWrapper>
  );
};

export const Newsletter2GoConnectView = connector(Newsletter2GoConnectViewComponent);
